import React from 'react';

import { rbacFlags } from '../utils/rbacFlags';

const Dashboard = React.lazy(() => import('../pages/Dashboard/Dashboard'));
const Report = React.lazy(() => import('../pages/Report/Report'));
const Vouchers = React.lazy(() => import('../pages/Vouchers'));
const Invoices = React.lazy(() => import('../pages/Invoices'));
const CreateVoucher = React.lazy(
  () => import('../pages/Vouchers/features/create-voucher/CreateVoucher')
);
const ViewVoucher = React.lazy(
  () => import('../pages/Vouchers/features/view-voucher/ViewVoucher')
);
const FundManageDetail = React.lazy(
  () => import('../pages/Vouchers/features/fund-manage/FundManageDetail')
);
const CreateOrg = React.lazy(() => import('../pages/CreateOrg/CreateOrg'));
const ManageAdmins = React.lazy(
  () => import('../pages/ManageAdmins/ManageAdmins')
);
const EmployeeDataDownload = React.lazy(
  () => import('../pages/EmployeeDataDownload/EmployeeDataDownload')
);

export const routes = [
  {
    key: 'DashboardTab',
    name: 'DashboardTab',
    route: '/dashboard',
    component: <Dashboard />,
  },
  {
    key: 'reports',
    name: 'reports',
    route: '/reports',
    component: <Report />,
  },
  {
    key: 'vouchers',
    name: 'vouchers',
    route: '/vouchers',
    component: <Vouchers />,
  },
  {
    key: 'create-voucher',
    name: 'create-voucher',
    route: '/create-voucher',
    component: <CreateVoucher />,
  },
  {
    key: 'view-voucher',
    name: 'view-voucher',
    route: '/view-voucher/:id',
    component: <ViewVoucher />,
  },
  {
    key: 'fund-manage',
    name: 'fund-manage',
    route: '/fund-manage/:id',
    component: <FundManageDetail />,
  },
  {
    key: 'EditOrgTab',
    name: 'EditOrgTab',
    route: '/edit-org/:orgId',
    component: <CreateOrg />,
  },
  {
    key: 'downloadEmployeeData',
    name: 'downloadEmployeeData',
    route: '/download/file-cache/:orgId/:id',
    component: <EmployeeDataDownload />,
  },
  {
    key: 'invoices',
    name: 'invoices',
    route: '/invoices',
    component: <Invoices />,
    requiredAccess: rbacFlags.CockpitInvoices,
  },
  {
    key: 'ManageAdmins',
    name: 'ManageAdmins',
    route: '/manage-admins',
    component: <ManageAdmins />,
    superAdminOnly: true,
  },
  {
    key: 'CreateOrgTab',
    name: 'CreateOrgTab',
    route: '/create-org',
    component: <CreateOrg />,
    superAdminOnly: true,
  },
];
